package br.com.texeratx.boardgametimeapp.ui.screens.games

import br.com.texeratx.boardgametimeapp.domain.usecases.games.GetGamesUseCase
import br.com.texeratx.boardgametimeapp.ui.screens.games.model.GameUI
import cafe.adriel.voyager.core.model.ScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.launch

class GamesViewModel(
    private val getGamesUseCase: GetGamesUseCase
) : ScreenModel {

    private var allGames: List<GameUI> = emptyList()

    val state = MutableStateFlow(GamesUiState())

    fun loadGames() {
        screenModelScope.launch {
            state.value = state.value.copy(isLoading = true, error = null)

            val result = getGamesUseCase()

            result.fold(
                onSuccess = { list ->
                    allGames = list

                    state.value = state.value.copy(
                        availableCategories = list.mapNotNull { it.category }.distinct(),
                        availableModes = list.mapNotNull { it.mode }.distinct()
                    )

                    applyFilters()
                },
                onFailure = {
                    state.value = state.value.copy(
                        isLoading = false,
                        error = it.message
                    )
                }
            )
        }
    }

    fun changeSort(option: GameSortOption) {
        state.value = state.value.copy(sort = option)
        applyFilters()
    }

    fun onSearch(query: String) {
        state.value = state.value.copy(searchQuery = query)
        applyFilters()
    }

    fun updateFilters(filters: GamesFilter) {
        state.value = state.value.copy(filters = filters)
        applyFilters()
    }

    private fun applyFilters() {
        val filtered = allGames
            .filter { game ->
                val f = state.value.filters

                val matchesSearch =
                    game.name.contains(state.value.searchQuery, ignoreCase = true)

                val matchesCategory =
                    f.category == null || game.category == f.category

                val matchesMode =
                    f.mode == null || game.mode == f.mode

                val matchesPlayers =
                    f.players == null ||
                            (
                                    (game.minPlayers ?: Int.MIN_VALUE) <= f.players &&
                                            (game.maxPlayers ?: Int.MAX_VALUE) >= f.players
                                    )

                matchesSearch &&
                        matchesCategory &&
                        matchesMode &&
                        matchesPlayers
            }
            .let { list ->
                when (state.value.sort) {
                    GameSortOption.ALPHABETICAL -> list.sortedBy { it.name }
                    GameSortOption.MOST_PLAYED -> list.sortedByDescending { it.matchesPlayed }
                }
            }

        state.value = state.value.copy(
            games = filtered,
            isLoading = false
        )
    }
}
